import React, { useContext, createContext } from "react";
import axiosFactory, { METHOD_GET, METHOD_POST } from "../helpers/AxiosFactory";
import {
  GET_ALL_MINE_QUESTIONS,
  UPDATE_PROFILE,
  UPDATE_USERNAME,
  UPDATE_LAWYER_PROFILE,
  BECOME_LAWYER,
  UPLOAD_IMAGE,
  CHANGE_PASSWORD,
  VERIFY_EMAIL,
  CHANGE_EMAIL,
} from "../helpers/UrlConstants";
const UserContext = createContext();
export function useUserContext() {
  return useContext(UserContext);
}
export default function UserProvider({ children }) {
  async function getAllMineQuestions() {
    return await axiosFactory({
      url: GET_ALL_MINE_QUESTIONS,
      method: METHOD_GET,
    });
  }
  async function verifyMyEmail(data) {
    return await axiosFactory({
      url: VERIFY_EMAIL,
      method: METHOD_POST,
      data: data,
    });
  }
  async function changeMyEmail(data) {
    return await axiosFactory({
      url: CHANGE_EMAIL,
      method: METHOD_POST,
      data: data,
    });
  }
  async function updateProfile(data) {
    return await axiosFactory({
      url: UPDATE_PROFILE,
      method: METHOD_POST,
      data: data,
    });
  }
  async function updateLawyerProfile(data) {
    return await axiosFactory({
      url: UPDATE_LAWYER_PROFILE,
      method: METHOD_POST,
      data: data,
    });
  }
  async function updateUsername(data) {
    return await axiosFactory({
      method: METHOD_POST,
      url: UPDATE_USERNAME,
      data: data,
    });
  }
  async function uploadImage(data) {
    return await axiosFactory({
      url: UPLOAD_IMAGE,
      method: METHOD_POST,
      data: data,
    });
  }
  async function becomeLawyerApplication(data) {
    return await axiosFactory({
      url: BECOME_LAWYER,
      method: METHOD_POST,
      data: data,
    });
  }
  async function changePassword(data) {
    return await axiosFactory({
      url: CHANGE_PASSWORD,
      method: METHOD_POST,
      data: data,
    });
  }
  const value = {
    getAllMineQuestions,
    updateProfile,
    updateLawyerProfile,
    becomeLawyerApplication,
    uploadImage,
    changePassword,
    verifyMyEmail,
    changeMyEmail,
    updateUsername
  };
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}
